import React, { useState } from "react";
import { FaPlane } from "react-icons/fa";
import { minutesToHrMin, parseTerminalName, StampTo24hr } from "../../../../../../../../Utils/utils";
import { Img } from "../../../../../../../../Components";
import { FiInfo } from "react-icons/fi";
import Layovers from "./layovers";
import moment from "moment";

function FlightCard({ duration, segments = [], className = "" }) {
	const departure = segments[0];
	const arrival = segments[segments.length - 1];
	const [ShowLayovers, setShowLayovers] = useState();

	const { departureTerminal, logo, departureTime, airlineName, airlineCode, flightNumber, departureCode } = departure || {};
	const { arrivalTime, arrivalCode, arrivalTerminal } = arrival || {};

	return (
		<>
			<div className="flex flex-col flex-1 min-w-0">
				{/* Airline: compact row on mobile; pb-2 when border shows so route row isn't double-spaced */}
				<div className="shrink-0 p-4 pb-2 flex items-center gap-3 border-b border-surface/50 md:border-0 md:pb-4">
					<Img src={logo} alt={airlineCode} className="w-10 h-10 rounded-full !bg-canvas shrink-0" />
					<div className="text-xs text-secondary min-w-0">
						<span className="font-medium text-dark">{airlineName}</span>
						<span className="ml-1">{airlineCode}-{flightNumber}</span>
					</div>
				</div>
				{/* Flight route: always one row (departure — duration — arrival) for a neat card */}
				<div className={`flex-grow p-4 flex-1 flex items-center gap-2 md:gap-x-4 flex-nowrap min-w-0 overflow-x-auto ${className}`}>
					<div className="shrink-0 max-w-[7rem] md:max-w-[8rem]">
						<div className="text-lg md:text-xl font-bold whitespace-nowrap">{StampTo24hr(departureTime)}</div>
						<div className="text-xs md:text-sm text-secondary">{departureCode}</div>
						{departureTerminal && <div className="text-xs text-secondary">{parseTerminalName(departureTerminal)}</div>}
					</div>
					<div className="flex-grow min-w-[4rem] md:min-w-[5rem] shrink-0 flex flex-col items-center">
						<div className="mb-1 text-xs text-center text-secondary whitespace-nowrap">{minutesToHrMin(duration)}</div>
						<div className="align-center w-full">
							<div className="w-2 h-2 border rounded-full border-dark shrink-0" />
							<div className="flex-grow border-t border-dashed border-muted min-w-0" />
							<FaPlane className="shrink-0 text-muted" />
							<div className="flex-grow border-t border-dashed border-muted min-w-0" />
							<div className="w-2 h-2 border rounded-full border-dark shrink-0" />
						</div>
						<div className="mt-1 text-xs text-center text-secondary whitespace-nowrap">
							{segments.length === 1
								? "Non-Stop"
								: `${segments.length - 1} stop (via ${segments
										.slice(1)
										?.map((segment) => `${segment.departureCode}`)
										.join(", ")})`}
						</div>
					</div>
					<div className="shrink-0 max-w-[7rem] md:max-w-[8rem]">
						<div className="text-lg md:text-xl font-bold whitespace-nowrap">{StampTo24hr(arrivalTime)}</div>
						<div className="text-xs md:text-sm text-secondary">{arrivalCode}</div>
						{arrivalTerminal && <div className="text-xs text-secondary">{parseTerminalName(arrivalTerminal)}</div>}
					</div>
				</div>
				{segments.length > 1 && (
					<div onClick={() => setShowLayovers(segments)} className="gap-2 p-2 border-t rounded-bl cursor-pointer flex-center bg-light hover:bg-canvas">
						<div className="gap-1 text-xs text-secondary flex-center">
							<FiInfo />
							Layovers
						</div>
						{segments.map((segment, i) => (
							<>
								<div key={i} className="w-5 h-1 mt-1 border-t border-dotted border-secondary" />
								<Img src={segment.logo} alt={airlineCode} className="w-6 h-6 rounded-full" />
							</>
						))}
					</div>
				)}
			</div>
			<Layovers segments={ShowLayovers} onClose={() => setShowLayovers()} />
		</>
	);
}

export default FlightCard;
